import AppConstants from "@/constants/AppConstants";
import { BOOL } from "@/constants/LocalStorageMap";
import LocalStorageService from "@/service/LocalStorageService";

/**
 * Whether the intro tutorial video should be shown automatically on load.
 * True only for a loaded, newer user who hasn't already seen it.
 *
 * @param {import("immutable").Map} user - Account state (Immutable Map from useAccountState)
 * @returns {boolean} True if the tutorial video should be shown
 */
export const shouldShowTutorialVideo = (user) => {
  if (!user.get("user_id")) return false;
  const alreadySeen = LocalStorageService.get(AppConstants.TUTORIAL_VIDEO_SEEN_KEY, BOOL);
  const isNewUser = user.get("accountAgeDays") <= AppConstants.TUTORIAL_VIDEO_MAX_ACCOUNT_AGE;
  return !alreadySeen && isNewUser;
};
